(() => {
  const selector = '[data-desson-daily]';

  function initializeDaily(section) {
    if (!section || section.dataset.dailyInitialized === 'true') return;
    const slides = [...section.querySelectorAll('[data-desson-daily-slide]')];
    const dots = [...section.querySelectorAll('[data-desson-daily-dot]')];
    if (slides.length < 2 || dots.length !== slides.length) return;

    let activeIndex = 0;
    let touchStartX = null;
    let pointerId = null;
    let pointerStartX = null;
    let pointerDragged = false;
    let suppressClick = false;
    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== activeIndex; });
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeIndex)));
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));
    section.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    section.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(distance) >= 48) showSlide(activeIndex + (distance < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    section.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerDragged = false;
    });
    section.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId || pointerStartX === null) return;
      if (Math.abs(event.clientX - pointerStartX) < 8) return;
      if (!pointerDragged) {
        pointerDragged = true;
        section.classList.add('is-dragging');
        section.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
    });
    const finishPointer = (event) => {
      if (event.pointerId !== pointerId || pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      if (pointerDragged && Math.abs(distance) >= 48) {
        showSlide(activeIndex + (distance < 0 ? 1 : -1));
        suppressClick = true;
        setTimeout(() => { suppressClick = false; }, 0);
      }
      section.classList.remove('is-dragging');
      if (section.hasPointerCapture(event.pointerId)) section.releasePointerCapture(event.pointerId);
      pointerId = null;
      pointerStartX = null;
      pointerDragged = false;
    };
    section.addEventListener('pointerup', finishPointer);
    section.addEventListener('pointercancel', finishPointer);
    section.addEventListener('click', (event) => {
      if (!suppressClick || !event.target.closest('a')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);
    section.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    section.dataset.dailyInitialized = 'true';
    showSlide(0);
  }

  const initializeAll = (root = document) => root.querySelectorAll(selector).forEach(initializeDaily);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
